import { render, staticRenderFns } from "./activar-cuenta.vue?vue&type=template&id=183789c0&scoped=true"
import script from "./activar-cuenta.vue?vue&type=script&lang=js"
export * from "./activar-cuenta.vue?vue&type=script&lang=js"
import style0 from "./activar-cuenta.vue?vue&type=style&index=0&id=183789c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183789c0",
  null
  
)

export default component.exports